import { useEffect, useState } from 'react';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { useAppDispatch } from 'app/store';
import { useParams } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { TabContext, TabList } from '@mui/lab';
import { Typography, Box, Tab } from '@mui/material';
import { StyledCard } from 'shared/ui/Card/StyledCard';
import { MoreInfo } from 'shared/ui/MoreInfo/MoreInfo';
import { useGetShopsByIdQuery } from 'widgets/product/ui/api/getShopsApi';
import { DrawerChangeProduct } from 'widgets/product/ui/DrawerChangeProduct';
import { LocalizationsType } from 'widgets/product/model/types';

type FormDataType = {
  image: string;
  lang: string;
  name: string;
  mechanic: string[];
  description: string;
  type: string;
  city: string[];
  registrationRange: string;
  activeRange: string;
  accessBonusRang: string;
  language_id: number;
  contents: any[];
};

export const ProductDetailWidget = () => {
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const [drawerVariant] = useState<{
    variant: 'edit';
    title: string;
  }>({
    variant: 'edit',
    title: 'Изменение данных',
  });

  const { id } = useParams();

  const { control } = useForm<FormDataType>({
    defaultValues: {
      image: '',
      lang: '',
      name: '',
      mechanic: [''],
      description: '',
      type: '',
      city: [''],
      registrationRange: '',
      activeRange: '',
      accessBonusRang: '',
    },
  });

  const { data: shop } = useGetShopsByIdQuery({ id: parseInt(id || '') });

  const local = { items: [] as LocalizationsType[] };

  shop?.localizations.map((a) => {
    if (a.language === 'RU') {
      local.items.push(a);
    }
  });
  shop?.localizations.map((b) => {
    if (b.language === 'KZ') {
      local.items.push(b);
    }
  });
  shop?.localizations.map((c) => {
    if (c.language === 'EN') {
      local.items.push(c);
    }
  });
  shop?.localizations.map((d) => {
    if (d.language === 'KG') {
      local.items.push(d);
    }
  });
  shop?.localizations.map((e) => {
    if (e.language === 'UZ') {
      local.items.push(e);
    }
  });

  const [tabValue, setTabValue] = useState('0');
  const handleChangeTabValue = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setHeaderTitle('Товар'));
  }, []);

  let cityStringList = '';

  shop?.cities.map((c) => {
    cityStringList = `${cityStringList + c.city_title},`;
  });

  if (cityStringList.endsWith(',')) {
    cityStringList = cityStringList.substring(0, cityStringList.length - 1);
  }
  return (
    <div>
      {shop && shop.localizations && (
        <Box
          component={StyledCard}
          sx={{
            marginBottom: '24px',
          }}
        >
          <Typography>Данные товара</Typography>
          <Controller
            control={control}
            name="language_id"
            render={() => (
              <Box sx={{ width: '100%' }}>
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList
                      onChange={handleChangeTabValue}
                      aria-label="basic tabs example"
                    >
                      <Tab
                        value="0"
                        label="RU"
                        {...a11yProps(0)}
                      />
                      <Tab
                        value="1"
                        label="KK"
                        {...a11yProps(1)}
                      />
                      <Tab
                        value="2"
                        label="EN"
                        {...a11yProps(2)}
                      />
                      <Tab
                        value="3"
                        label="KG"
                        {...a11yProps(3)}
                      />
                      <Tab
                        value="4"
                        label="UZ"
                        {...a11yProps(4)}
                      />
                    </TabList>
                  </Box>
                  {local.items.map((item, index) => (
                    <TabPanel
                      value={+tabValue}
                      index={index}
                    >
                      <Box
                        style={{
                          display: 'flex',
                          marginTop: '12px',
                        }}
                      >
                        <div
                          className="column"
                          style={{ width: '300px' }}
                        >
                          <MoreInfo>
                            <div className="title">Фото</div>
                            <img
                              style={{ width: '200px' }}
                              src={local.items[index].image || ''}
                              alt="Нет фото"
                            />
                          </MoreInfo>
                        </div>
                        <div
                          className="column"
                          style={{ width: '250px' }}
                        >
                          <MoreInfo>
                            <div className="title">Название товара</div>
                            <div className="content">{local.items[index].localization_title ?? '---'}</div>
                          </MoreInfo>
                          <MoreInfo>
                            <div className="title">Описание</div>
                            <div className="content">{local.items[index].description ?? '---'}</div>
                          </MoreInfo>
                        </div>
                      </Box>
                    </TabPanel>
                  ))}
                </TabContext>
              </Box>
            )}
          />
        </Box>
      )}
      <div
        className="column"
        style={{ width: '700px' }}
      >
        <MoreInfo>
          <div className="title">Категория</div>
          <div className="content">{shop?.product_category_title ?? '---'}</div>
        </MoreInfo>
        <MoreInfo>
          <div className="title">Партнер</div>
          <div className="content">{shop?.partner_title ?? '---'}</div>
        </MoreInfo>
        <MoreInfo>
          <div className="description">Города</div>
          <div className="content">{cityStringList}</div>
        </MoreInfo>
      </div>
      {drawerVariant.variant === 'edit' && (
        <Box>
          <DrawerChangeProduct product={shop} />
        </Box>
      )}
    </div>
  );
};
